import { useRouteError } from 'react-router-dom';

const ErrorBoundary = () => {
  const error = useRouteError();

  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack : undefined;

  return (
    <div className="container flex h-dvh items-center justify-center">
      <div className="flex flex-col gap-4">
        <div className="text-center">
          <h1 className="text-4xl font-bold">Oops! 😥🙇‍♂️</h1>
          <p className="text-lg">Something went wrong.</p>
        </div>
        <div className="flex flex-col">
          <div>
            Contact Us:{' '}
            <span className="font-bold">matichon.man@float16.cloud</span>
          </div>
          <div>
            Discord:{' '}
            <a
              href="https://discord.gg/j2DVTMjr67"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Float16
            </a>
          </div>
        </div>
        <section
          className="relative rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
          role="alert"
        >
          <h1 className="mb-2 text-xl font-bold">Error Boundary</h1>
          <p className="mb-2">The following error during render:</p>
          <pre className="overflow-x-auto rounded bg-red-50 p-2 text-sm">
            <code>
              {errorMessage}
              {errorStack && `\n\nStack trace:\n${errorStack}`}
            </code>
          </pre>
        </section>
      </div>
    </div>
  );
};
export default ErrorBoundary;
